import { render, staticRenderFns } from "./surveyTypeDictionary.vue?vue&type=template&id=0766ad9c&scoped=true&"
import script from "./surveyTypeDictionary.vue?vue&type=script&lang=ts&"
export * from "./surveyTypeDictionary.vue?vue&type=script&lang=ts&"
import style0 from "./surveyTypeDictionary.vue?vue&type=style&index=0&id=0766ad9c&lang=scss&scoped=true&"
import style1 from "./surveyTypeDictionary.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0766ad9c",
  null
  
)

export default component.exports